import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var NewConstructionSVG = function NewConstructionSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M39.246,15.781l-16-5.715a1.188,1.188,0,0,0-1.052.137,1.16,1.16,0,0,0-.48.938V26.4L19.05,24.01a1.128,1.128,0,0,0-1.532,0l-6.652,5.966a1.78,1.78,0,0,0-.582,1.3v9.269A1.453,1.453,0,0,0,11.735,42H38.857A1.146,1.146,0,0,0,40,40.857v-24A1.15,1.15,0,0,0,39.246,15.781Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M36.582,9.5l-18-6.429a1.327,1.327,0,0,0-1.183.154,1.3,1.3,0,0,0-.54,1.054V21.449l-3-2.688a1.268,1.268,0,0,0-1.723,0L4.656,25.473A2,2,0,0,0,4,26.939V37.367A1.635,1.635,0,0,0,5.633,39H36.145a1.29,1.29,0,0,0,1.286-1.286v-27A1.292,1.292,0,0,0,36.582,9.5Zm-22.3,26.924H11.715V32.571h2.571Zm5.144,0H16.858v-4.5A1.926,1.926,0,0,0,14.929,30H11.072a1.927,1.927,0,0,0-1.929,1.929v4.5H6.572V27.209L13,21.436l6.429,5.773Zm15.429,0H22V26.939a2,2,0,0,0-.655-1.466L19.4,23.725c0-.052.026-.1.026-.155V6.109l15.429,5.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M31,17.141V30a1.286,1.286,0,1,1-2.572,0V17.141a1.286,1.286,0,0,1,2.572,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M25.859,14.57V30a1.286,1.286,0,1,1-2.572,0V14.57a1.286,1.286,0,0,1,2.572,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M13,7.043h-.043A3.958,3.958,0,0,1,9,3.086V3A1,1,0,0,0,7,3v.086A3.958,3.958,0,0,1,3.043,7.043H3a1,1,0,1,0,0,2h.043A3.958,3.958,0,0,1,7,13H7a1,1,0,0,0,2,0H9a3.958,3.958,0,0,1,3.957-3.957H13a1,1,0,1,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M41.134,24.043h-.043a3.957,3.957,0,0,1-3.957-3.957V20a1,1,0,0,0-2,0v.086a3.958,3.958,0,0,1-3.957,3.957h-.043a1,1,0,0,0,0,2h.043A3.958,3.958,0,0,1,35.134,30h0a1,1,0,0,0,2,0h0a3.957,3.957,0,0,1,3.957-3.957h.043a1,1,0,0,0,0-2Z"
  }));
};
NewConstructionSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
NewConstructionSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "New Construction")
};
export default withDetailedIcon(NewConstructionSVG);